import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet ,useNavigate,useMatch } from "react-router-dom";
import { loginSelector } from "../store/slices/loginSlice";
import {useLocation}from "react-router";

const SpecialApprovelv7Routes = (props: any) => {
    const loginReducer = useSelector(loginSelector);
    const auth = loginReducer.result;
    const prevLocation = useLocation();
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch("/approvepricelistspecialid2/:id");

    let id = match?.params.id;
    // return auth  ?<Navigate to="/approve" />:<Navigate to="/login" />;
    let linkpage = "/approvepricelistspecial/"+id
    // return auth  ?<Navigate to="/approve" />:<Navigate to="/login" />;
    return auth  ? <Navigate to={linkpage} />:<Navigate to="/login"/>;
 
};

export default SpecialApprovelv7Routes;